import { ApolloClient, createHttpLink, from, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/react';
import { message } from 'antd';

import { ACCOUNT_URL } from '../config';
import { SENTRY_IGNORE_STATUS } from '../Constants/commonConstants';
import { getValidAccessToken, redirectToLogin } from './authUtils';

const secondaryHttpLink = createHttpLink({
  uri: `${ACCOUNT_URL}/graphql/`,
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.message === 'Unauthorized access: Invalid user') {
        redirectToLogin();
      }
    }
  }
  if (networkError) {
    if (networkError.message) {
      message.error(networkError.message);
      console.error(networkError);
    }
    if (networkError?.statusCode && !SENTRY_IGNORE_STATUS.includes(networkError.statusCode)) {
      Sentry.captureException(networkError);
    }
    // If refresh fails, redirect to login
    if ('statusCode' in networkError && networkError?.statusCode === 401) {
      redirectToLogin();
    }
  }
});

export const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = await getValidAccessToken();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const accountsClient = new ApolloClient({
  link: from([authLink, errorLink, secondaryHttpLink]),
  cache: new InMemoryCache(),
});
